import React from 'react'

import { PaginateProps } from '@customTypes'

import { StyledPaginate } from './components/StyledPaginate'

export const Paginate: React.FC<PaginateProps> = ({
  ...props
}) => (
      <StyledPaginate
        previousLabel="prev"
        nextLabel="next"
        activeClassName="active"
        marginPagesDisplayed={1}
        pageRangeDisplayed={3}
        {...props}
      />
  )
